export default __webpack_public_path__ + "static/media/slots-rebate-ico.0c8eb3df.svg";